import React, { useState, useEffect } from "react";

import { useApolloClient } from "@apollo/client";

import { Chart } from 'primereact/chart';
import { Calendar } from "primereact/calendar";
import { Button } from 'primereact/button';
import { SUMBOOKING } from "../../../provider/Bookings/query";
import { useUser } from "../../../context/users";
import { Dropdown } from "primereact/dropdown";

const Metrics = () => {
  const apollo = useApolloClient();

  const user = useUser();
  const franchise_id = user?.getUser()?.franchise?.id;
  const acting_region_id = user?.getUser()?.actingRegion?.id;

  const [franchise, setFranchise] = React.useState<any>(null);
  const [franchises, setFranchises] = React.useState<iFranchise[]>([]);
  const [region, setRegion] = React.useState<any>(null);
  const [regions, setRegions] = React.useState<iRegion[]>([]);
  const [load, setLoad] = React.useState(true);
  const [reload, setReload] = React.useState<boolean>(false);

  const initialState = {
    countCanceled: 0,
    countCompleted: 0,
    countRace: 0,
    final_value: 0,
    countDrivers: 0,
    countDriversOn: 0,
  }
  const [sumBookings, setSumBookings] = useState<any>(initialState);
  const [iniDate, setIniDate] = useState<any>(new Date());
  const [finDate, setFinDate] = useState<any>(new Date());

  useEffect(() => {
    loadBookings()
  }, [iniDate, finDate, region?.code]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (franchise?.code){
      setRegion(null);
      setReload(true);
      loadBookings();
    }
  }, [franchise?.code]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadBookings = () => {
    if (finDate >= iniDate) {
      const ini_date = `${iniDate.getFullYear()}-${iniDate.getMonth()+1}-${iniDate.getDate()} 00:00:00.000`;
      const fin_date = `${finDate.getFullYear()}-${finDate.getMonth()+1}-${finDate.getDate()} 23:59:59.999`;

      getBookings(ini_date, fin_date);
    }
  }

  const getBookings = (ini_date: string, fin_date: string) => {

    const filter: any = {
      ini_date: ini_date,
      fin_date: fin_date,
    };

    if (franchise_id) filter.franchise_id = Number(franchise_id);
    if (acting_region_id) filter.acting_region_id = Number(acting_region_id);

    if (franchise?.code) filter.franchise_id = Number(franchise.code);

    if (region?.code) filter.acting_region_id = Number(region.code);

    apollo
      .query({
        query: SUMBOOKING,
        variables: filter,
      })
      .then(response => {
        const data = response.data.sumBookings;
        setSumBookings(data)

        setFranchises(response.data.franchises);
        setRegions(response.data.regions);
        setLoad(false);
        setReload(false);
      })
      .catch(error => {
        console.log('error recebido: ', JSON.stringify(error));
        setLoad(false);
        setReload(false);
      });
  };

  const pieData = {
    labels: ['Canceladas', 'Completas'],
    datasets: [
      {
        data: [sumBookings.countCanceled, sumBookings.countCompleted, sumBookings.countRace - sumBookings.countCanceled],
        backgroundColor: ['rgb(255, 99, 132)', 'rgb(75, 192, 192)', 'rgb(54, 162, 235)']
      }
    ]
  };

  const pieDataDrivers = {
    labels: ['Online'],
    datasets: [
      {
        data: [sumBookings.countDriversOn, sumBookings.countDrivers - sumBookings.countDriversOn],
        backgroundColor: ['rgb(75, 192, 192)', 'rgb(54, 162, 235)']
      }
    ]
  };

  const pieOptions = {
    plugins: {
      legend: {
        labels: {
          color: '#495057'
        }
      }
    }
  };

  return (
    <>
      {franchise_id && acting_region_id ? null : (
        load ? (
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
        ) : (
          <>
            <div className="card">
              <div className="flex flex-column md:flex-row flex-wrap">
                { !franchise_id ? (
                  <div className="flex flex-column md:flex-row flex-wrap">
                    <label htmlFor="name">Franquia</label>
                    <div className="field col-12 md:col-12">
                      <Dropdown
                        value={franchise}
                        onChange={e => setFranchise(e.value)}
                        options={franchises.map(i => ({ code: i.id, name: i.name }))}
                        optionLabel="name"
                        placeholder="Selecione uma Franquia"
                      />
                    </div>
                  </div>
                ) : null }
  
  
                { !acting_region_id ? (
                  <div className="flex flex-column md:flex-row flex-wrap">
                    <label htmlFor="name">Região</label>
                    <div className="field col-12 md:col-12">
                      {reload ? (
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
                      ) : (
                        <Dropdown
                          value={region}
                          onChange={e => setRegion(e.value)}
                          options={regions.map(i => ({ code: i.id, name: i.name }))}
                          optionLabel="name"
                          placeholder="Selecione uma Região"
                        />
                      )}
                    </div>
                  </div>
                ) : null }
              </div>
            </div>
          </>
        )
      )}
      <div className="grid p-fluid">
        <div className="col-12 lg:col-6">
          <div className="card">
            <h5>Data Inicial</h5>
            <Calendar showIcon showButtonBar value={iniDate} onChange={e => setIniDate(e.value)} dateFormat="dd/mm/yy" />
          </div>
        </div>
        <div className="col-12 lg:col-6">
          <div className="card">
            <h5>Data Final</h5>
            <Calendar showIcon showButtonBar value={finDate} onChange={e => setFinDate(e.value)} dateFormat="dd/mm/yy" />
          </div>
        </div>
        <div className="col-12 lg:col-6">
          <div className="card flex flex-column align-items-center">
            <Chart type="doughnut" data={pieData} options={pieOptions} style={{ width: '50%' }} />
            <h5>Corridas</h5>
          </div>
        </div>
        <div className="col-12 lg:col-6">
          <div className="card flex flex-column align-items-center">
            <Chart type="doughnut" data={pieDataDrivers} options={pieOptions} style={{ width: '50%' }} />
            <h5>Motoristas</h5>
          </div>
        </div>
        <div className="card">
          <Button label={`Total: R$ ${(sumBookings.final_value/100).toFixed(2)}`} className="p-button-outlined p-button-success mr-2 mb-2" />
        </div>
        <div className="card">
          <Button label={`Corridas hoje: ${sumBookings.countRace}`} className="p-button-outlined p-button-warning mr-2 mb-2" />
        </div>
        <div className="card">
          <Button label={`Corridas finalizadas: ${sumBookings.countCompleted}`} className="p-button-outlined p-button-success mr-2 mb-2" />
        </div>
        <div className="card">
        <Button label={`Corridas canceladas: ${sumBookings.countCanceled}`}  className="p-button-outlined p-button-danger mr-2 mb-2" />
        </div>
      </div>
    </>
  );
};

export default Metrics;
